@if (gate(); as gate) {
  <onyx-text-field
    [formControl]="gate"
    placeholder="labels.gate"
    [size]="32"
    [showErrors]="false"
  ></onyx-text-field>
}
